<template>
  <div>

    <c-title>Willkommen {{ $store.state.user.data.first_name }} {{ $store.state.user.data.last_name }}</c-title>

    <div v-if="$is(['applicant', 'css_supervisor', 'professor'])">
      <c-process-overview />
    </div>

    <div v-if="$is(['teacher', 'css_supervisor', 'professor'])">
      <c-title
        v-if="$is(['teacher'])"
        tag="h2"
      >
        Claussen-Simon-Wettbewerb für Schulen
      </c-title>
      <c-title
        v-if="$is(['professor'])"
        tag="h2"
      >
        Claussen-Simon-Wettbewerb für Hochschulen
      </c-title>
      <c-title
        v-if="$is(['css_supervisor'])"
        tag="h2"
      >
        Claussen-Simon-Wettbewerbe
      </c-title>
      <c-project-overview />
    </div>

    <c-card v-if="$is(['student']) && new Date($store.state.user.data.project_deadline_whs) > new Date()">
      {{ $store.state.user.data.project_deadline_whs }}
      {{ new Date($store.state.user.data.project_deadline_whs) }}
      <div>
        <c-title tag="h2">Claussen-Simon-Wettbewerb für Hochschulen</c-title>
      </div>

      <div v-if="$is(['student'])">
        <c-title tag="h3">Empfehlungsphase</c-title>
        <c-button-router-link
          v-if="new Date($store.state.user.data.suggestion_deadline_whs) > new Date()"
          :to="{ name: 'project-suggest-professor' }"
        >
          Professor/-in vorschlagen
        </c-button-router-link>
        <p v-else>
          Die Empfehlungsphase ist momentan geschlossen.
        </p>
      </div>

      <div v-if="$is(['student'])">
        <c-title tag="h3">Bewertungsphase</c-title>
        <c-project-code-prompt
          v-if="new Date($store.state.user.data.suggestion_deadline_whs) < new Date() &&
          new Date($store.state.user.data.project_deadline_whs) > new Date()"
          to="project-rating"
        />
        <p v-else>
          Die Bewertungsphase ist momentan geschlossen.
        </p>
      </div>
    </c-card>

    <c-card v-if="new Date($store.state.user.data.project_deadline_ws) > new Date()">
      <div>
        <c-title tag="h2">Claussen-Simon-Wettbewerb für Schulen</c-title>
      </div>

      <div v-if="$is(['pupil'])">
        <c-title tag="h3">Empfehlungsphase</c-title>
        <c-button-router-link
          v-if="new Date($store.state.user.data.suggestion_deadline_ws) > new Date()"
          :to="{ name: 'project-suggest-teacher' }"
        >
          Lehrer/-in vorschlagen
        </c-button-router-link>
        <p v-else>
          Die Empfehlungsphase ist momentan geschlossen.
        </p>
      </div>

      <div v-if="$is(['pupil'])">
        <c-title tag="h3">Bewertungsphase</c-title>
        <c-project-code-prompt
          v-if="new Date($store.state.user.data.suggestion_deadline_ws) < new Date() &&
          new Date($store.state.user.data.project_deadline_ws) > new Date()"
          to="project-rating"
        />
        <p v-else>
          Die Bewertungsphase ist momentan geschlossen.
        </p>
      </div>
    </c-card>

    <div v-if="$is(['applicant', 'student', 'pupil'])">
      <c-title tag="h2">Programm wählen</c-title>
      <p>Die Claussen-Simon-Stiftung bietet Förderprogramme in den Bereichen Bildung & Schule, Wissenschaft & Hochschule
      und Kunst & Kultur an. Auch wenn Sie bereits an einem Programm teilgenommen haben, können Sie ein weiteres
      auswählen und sich bewerben. Weitere Informationen zu den verschiedenen Förderprogrammen erhalten Sie auf der <a
        href="https://www.claussen-simon-stiftung.de"
        rel="noopener"
        target="_blank"
      >Website der
      Claussen-Simon-Stiftung</a>.</p>

      <c-button-router-link :to="{ name: 'select-role' }">
        Neues Programm
      </c-button-router-link>
    </div>

  </div>
</template>

<script>
import CButtonRouterLink from '@/components/CButtonRouterLink'
import CCard from '@/components/CCard'
import CProcessOverview from '@/components/process/CProcessOverview'
import CProjectOverview from '@/components/project/CProjectOverview'
import CProjectCodePrompt from '@/components/project/CProjectCodePrompt'
import CTitle from '@/components/CTitle'

export default {
  name: 'VDashboardIntroduction',

  components: {
    CButtonRouterLink,
    CCard,
    CProcessOverview,
    CProjectOverview,
    CProjectCodePrompt,
    CTitle
  }
}
</script>
<style scoped>
.competition {
  background-color: #fff;
  padding: 10px;
}

.competition + .competition {
  margin-top: 30px;
}
</style>
